import React, { Component } from 'react';
import TitlePage from '../../containers/Header/TitlePage';
import NavBar from '../../containers/Header/NavBar';
import { Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setRecipientDetails } from '../../actions/recipientDetails';
import './RecipientDetails.css';

class RecipientDetails extends Component {
  render() {
    const { setRecipientDetails, recipientDetails } = this.props;
    return (
      <div className="recipient-details-page">
        <TitlePage />
        <NavBar {...this.props} />
        <div className="recipient-details">
          <h1>Recipient Details</h1>
          <Form>
            <FormGroup>
              <Label for="title">Title</Label>
              <Input
                type="text"
                name="title"
                id="title"
                value={recipientDetails.title}
                onChange={e => setRecipientDetails(e.target.value, 'title')}
              />
            </FormGroup>
            <FormGroup>
              <Label for="practice">Medical Practice</Label>
              <Input
                type="text"
                name="practice"
                id="practice"
                value={recipientDetails.practice}
                onChange={e => setRecipientDetails(e.target.value, 'practice')}
              />
            </FormGroup>
            <FormGroup>
              <Label for="street">Street</Label>
              <Input
                type="text"
                name="street"
                id="street"
                value={recipientDetails.street}
                onChange={e => setRecipientDetails(e.target.value, 'street')}
              />
            </FormGroup>
            <FormGroup>
              <Label for="city">City</Label>
              <Input
                type="text"
                name="city"
                id="city"
                value={recipientDetails.city}
                onChange={e => setRecipientDetails(e.target.value, 'city')}
              />
            </FormGroup>
            <FormGroup>
              <Label for="state">State</Label>
              <Input
                type="text"
                name="state"
                id="state"
                value={recipientDetails.state}
                onChange={e => setRecipientDetails(e.target.value, 'state')}
              />
            </FormGroup>
            <FormGroup>
              <Label for="postcode">Postcode</Label>
              <Input
                type="text"
                name="postcode"
                id="postcode"
                value={recipientDetails.postcode}
                onChange={e => setRecipientDetails(e.target.value, 'postcode')}
              />
            </FormGroup>
            <Button
              color="success"
              onClick={() => this.props.history.push('PatientHome')}
              className="question-button"
            >
              Save
            </Button>
          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  recipientDetails: state.recipientDetails,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setRecipientDetails,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RecipientDetails);



// WEBPACK FOOTER //
// ./src/components/RecipientDetails/RecipientDetails.js